import { Action } from 'redux-actions'
import { all, call, put, takeEvery } from 'redux-saga/effects'
import api from '../../../services/api.services'
import {
  DeleteAnnouncements$Request,
  DeleteFile$Request,
  DeleteFile$Response,
  SaveImage$Request,
} from '../../../services/api.types'
import { deleteFile, uploadImage, uploadImageFail, uploadImageSuccess } from './UploadActions'
import { addNotification, clearNotification } from '../../../common/notifications/NotificationActions'
import { INotification } from '../../../common/notifications/NotificationReducers'
import { t } from 'ttag'
import { scrollToTop } from '../../../common/helpers/scroll'
import { push } from 'connected-react-router'
import { ROUTES } from '../../../common/Routes/routePaths'
import {
  deleteAnnouncementsFail,
  deleteAnnouncementsSuccess,
} from '../../../views/Announcements/store/AnnouncementsActions'

function* sagaUpload(action: Action<SaveImage$Request>) {
  try {
    yield put({ type: String(clearNotification) })

    const formData = new FormData()
    formData.append('file', action.payload.file)
    formData.append('companyId', action.payload.companyId)

    // @ts-ignore
    const { fileDto } = yield call(api.upload.uploadImage, formData)
    yield put({ type: String(uploadImageSuccess), payload: fileDto })
  } catch (e: any) {
    console.log('UploadFail: ', e)
    yield put({ type: String(uploadImageFail), payload: new Date().getTime() })

    // const msg = e.message
    let content = t`Upload failed. Please try again!`
    if (e.status == 413) {
      content = t`Maximum upload size exceeded. Please try again!`
    }

    const errorNotification: INotification = {
      type: 'warning',
      content,
    }
    yield put({ type: String(addNotification), payload: errorNotification })
    scrollToTop()
  }
}

function* sagaDeleteFile(action: Action<DeleteFile$Request>) {
  try {
    yield call(api.upload.deleteFile, action.payload)
    //yield put({ type: String(deleteAnnouncementsSuccess) })
  } catch (e: any) {
    console.log('DeleteFileFail: ', e)
    //yield put({ type: String(deleteAnnouncementsFail) })
  }
}

export function* uploadSagas() {
  yield all([takeEvery(String(uploadImage), sagaUpload), takeEvery(String(deleteFile), sagaDeleteFile)])
}
